import React from 'react';

function low() {
    return (
        <svg width="50" height="52" viewBox="0 0 50 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_0_1)">
                <line x1="16.5" y1="8.5" x2="16.5" y2="27.5" stroke="#F9BD4A" strokeWidth="3" strokeLinecap="round"/>
            </g>
            <line x1="24.5" y1="8.5" x2="24.5" y2="27.5" stroke="#F9BD4A" strokeWidth="3" strokeLinecap="round"/>
            <line x1="32.5" y1="8.5" x2="32.5" y2="27.5" stroke="#DEE3EF" strokeWidth="3" strokeLinecap="round"/>
            <line x1="40.5" y1="8.5" x2="40.5" y2="27.5" stroke="#DEE3EF" strokeWidth="3" strokeLinecap="round"/>
            <line x1="48.5" y1="8.5" x2="48.5" y2="27.5" stroke="#DEE3EF" strokeWidth="3" strokeLinecap="round"/>
            <defs>
                <filter id="filter0_d_0_1" x="0" y="0" width="33" height="52" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="8"/>
                    <feGaussianBlur stdDeviation="7.5"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0.976471 0 0 0 0 0.741176 0 0 0 0 0.290196 0 0 0 0.3 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape"/>
                </filter>
            </defs>
        </svg>




    );
}

export default low;
